import { Model } from "./Concers/Model";

export class Component extends Model {
    id: number;
    component_type_id: number;
    content: string;
    article_id: number;
    parent_id: number;
    order: number;
    created_at: string;
    updated_at: string;
    translations: any; // Keep for PDF ID access

    public translatable = ["content"];

    constructor(item) {
        super(item);
    }
}
